import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class TagsInput extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : '',
        nameClass : ''
    };

    componentDidMount() {
        this.setState({
            val: this.props.val,
            nameClass: this.props.nameClass
        },() => {
            if(this.props.typeahead === true) // tags typeahead type
            {
                this.tagsTypeahead(this.props.dataItems);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.typeahead !== true)
        {
            $('#' + this.props.id).tagsinput('destroy');    
        }
        
        this.setState({
            val: nextProps.val
        },() => {
            $('#' + this.props.id).tagsinput();
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleChange = (e) => {
        this.setState({val : e.target.value});
        if(this.props.passValue) {
            this.props.passValue(e);
        }
    }

    tagsTypeahead = (items) => {
        // let price = 0;

        $('.' + this.state.nameClass).tagsinput({
            itemValue: 'id',
            itemText: (item) => {
                return item.procedure + ' - ' + item.price
            },
            typeaheadjs: {
                display: 'procedure',
                source: items

              }
        });

        $('.' + this.state.nameClass).on('beforeItemAdd', (event) => {
            if(typeof event.item.price !== 'undefined')
            {
                // price += Number(event.item.price.replace(".00",""));
                
                this.props.onItemAdded(event.item);    
            }
            
        });

        $('.' + this.state.nameClass).on('itemRemoved', (event) => {
            this.props.onItemRemove(event.item);
        });

    }

    render() {
        var className = this.state.val ? 'form-control ' + this.state.nameClass : 'form-control ' + this.state.nameClass;

        return (
            <div className="form-group form-md-line-input">
                <input type="text" className={className} id={this.props.id}
                       name={this.props.id}
                       onChange={this.handleChange}
                       
                       data-role="tagsinput"/>

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block">{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/TagsInput.js
 **/